import { Alert, Link } from '@apollo/orbit';
import React from 'react';

interface Props {
  className?: string;
}

export const ConnectorsQueryPlanAlert = ({ className }: Props) => (
  <Alert status="info" className={className}>
    Query plan previews in Studio are incomplete and don’t represent connectors
    yet. A more detailed view is coming soon.{' '}
    <Link
      to="https://go.apollo.dev/connectors/best-practices#inconsistent-query-plan-diagrams"
      isExternal
    >
      Learn more
    </Link>
  </Alert>
);
